module.exports = __webpack_public_path__ + "static/img/pa5.2ce930e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/v1/pa5.png
// module id = nLhR
// module chunks = 0